/**
 * Button placement for Form / Filter.
 * @hidden
 */
export enum ButtonPlacement {
    Default = 1,
    BottomLeft = 2,
    BottomRight = 3,
    BottomCenter = 4
}